/**
 * Browser compatibility detection and feature support
 */
export class BrowserCompatibility {
  // Browser detection
  static isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
  static isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent)
  static isChrome = /chrome/i.test(navigator.userAgent) && !/edge/i.test(navigator.userAgent)
  static isEdge = /edge/i.test(navigator.userAgent)
  static isFirefox = /firefox/i.test(navigator.userAgent)

  // Feature detection
  static supportsFileSystemAccess = 
    'showOpenFilePicker' in window && 
    'showDirectoryPicker' in window &&
    'showSaveFilePicker' in window

  static supportsOriginPrivateFS = 
    'storage' in navigator && 
    'getDirectory' in navigator.storage

  static supportsFileHandle = 'FileSystemFileHandle' in window
  
  // Get browser info
  static getBrowserInfo() {
    return {
      name: this.getBrowserName(),
      isSafari: this.isSafari,
      isIOS: this.isIOS,
      isChrome: this.isChrome,
      isEdge: this.isEdge,
      isFirefox: this.isFirefox,
      features: {
        fileSystemAccess: this.supportsFileSystemAccess,
        originPrivateFS: this.supportsOriginPrivateFS,
        fileHandle: this.supportsFileHandle
      }
    }
  }

  static getBrowserName(): string {
    if (this.isSafari) return 'Safari'
    if (this.isChrome) return 'Chrome'
    if (this.isEdge) return 'Edge'
    if (this.isFirefox) return 'Firefox'
    return 'Unknown'
  }

  // Check if we should use fallback mode
  static shouldUseFallback(): boolean {
    return !this.supportsFileSystemAccess || this.isSafari || this.isIOS
  }

  // Get appropriate storage mode
  static getStorageMode(): 'native' | 'fallback' | 'electron' {
    // Check if running in Electron
    if (typeof window !== 'undefined' && window.api) {
      return 'electron'
    }
    
    // Check if File System Access API is supported
    if (this.supportsFileSystemAccess && !this.isSafari) {
      return 'native'
    }
    
    // Use fallback for Safari and unsupported browsers
    return 'fallback'
  }
}